// @ts-nocheck

import { request } from '../context';
import type { ApiOptions } from '../context';
import type { BaseResponseKcsConfigFoundResponse, PostKcsConfigsBody } from '../types';

/**
 * findAll
 *
 * @export
 * @tags kcs配置
 * @link [GET] /kcsConfigs
 */
export function getKcsConfigs(): Promise<BaseResponseKcsConfigFoundResponse>;
export function getKcsConfigs(
    options: ApiOptions<never, never>
): Promise<BaseResponseKcsConfigFoundResponse>;
export function getKcsConfigs(
    options?: ApiOptions<never, never>
): Promise<BaseResponseKcsConfigFoundResponse> {
    return request<never, never, never>('/kcsConfigs', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getKcsConfigs',
    });
}

/**
 * save
 *
 * @export
 * @tags kcs配置
 * @link [POST] /kcsConfigs
 */
export function postKcsConfigs(
    data: PostKcsConfigsBody
): Promise<BaseResponseKcsConfigFoundResponse>;
export function postKcsConfigs(
    data: PostKcsConfigsBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseKcsConfigFoundResponse>;
export function postKcsConfigs(
    data: PostKcsConfigsBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseKcsConfigFoundResponse> {
    return request<PostKcsConfigsBody, never, never>('/kcsConfigs', {
        ...options,
        data,
        method: 'post',
        __$requestCalleeName: 'postKcsConfigs',
    });
}

export const meta = [
    { tags: ['kcs配置'], path: '/kcsConfigs', method: 'get' },
    { tags: ['kcs配置'], path: '/kcsConfigs', method: 'post' },
];
